import type { BuyingFormData } from '../types/buyingForm';

type TranslationFunction = (key: string) => string;

export const getEmploymentStatusDisplay = (status: string, t?: TranslationFunction): string => {
  if (!t || !status) return status;
  
  const translationMap: { [key: string]: string } = {
    'employed': 'buyingForm.employed',
    'self-employed': 'buyingForm.selfEmployed',
    'unemployed': 'buyingForm.unemployed',
    'retired': 'buyingForm.retired',
    'student': 'buyingForm.student'
  };
  
  const key = translationMap[status];
  return key ? t(key) : status;
};

export const getCreditScoreDisplay = (score: string, t?: TranslationFunction): string => {
  if (!t || !score) return score;
  
  const translationMap: { [key: string]: string } = {
    'excellent': 'buyingForm.excellent',
    'good': 'buyingForm.good',
    'fair': 'buyingForm.fair',
    'poor': 'buyingForm.poor',
    'bad': 'buyingForm.bad'
  };
  
  const key = translationMap[score];
  return key ? t(key) : score;
};

export const formatAddress = (formData: BuyingFormData, t?: TranslationFunction): string => {
  const { address, country, city, state, zipCode } = formData;
  const parts = [address, city, state, zipCode].filter(Boolean);
  if (country) parts.push(country);
  if (parts.length > 0) {
    return parts.join(', ');
  }
  return t ? t('buyingForm.notProvided') : 'Not provided';
};

export const formatCurrency = (amount: string, t?: TranslationFunction): string => {
  if (!amount) return t ? t('buyingForm.notProvided') : 'Not provided';
  return `${Number(amount).toLocaleString()}`;
};

export const canSubmitForm = (formData: BuyingFormData): boolean => {
  return formData.termsAccepted && 
         formData.softCreditCheckAccepted && 
         formData.hardCreditCheckAccepted && 
         formData.dataConsentAccepted;
};

export const getInitialFormData = (): BuyingFormData => ({
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  dateOfBirth: '',
  address: '',
  country: '',
  city: '',
  state: '',
  zipCode: '',
  employmentStatus: '',
  employer: '',
  jobTitle: '',
  monthlyIncome: '',
  creditScore: '',
  existingDebts: '',
  downPayment: '',
  references: '',
  emergencyContact: '',
  termsAccepted: false,
  softCreditCheckAccepted: false,
  hardCreditCheckAccepted: false,
  dataConsentAccepted: false
});